import { CommonModule } from "@angular/common";
import { OnInitDirective } from "./init.directive";
import { NgModule } from "@angular/core";


@NgModule({
    declarations: [
        OnInitDirective
    ],
    imports: [CommonModule],
    exports: [
        OnInitDirective
    ],
  })
  export class SharedDirectivesModule {}